/* Silicium · Sistema v6 · animaciones + accesibilidad */
(function(){
  'use strict';
  document.documentElement.classList.add('js-ready');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupReveal(){
    var els = document.querySelectorAll('.reveal, .reveal-stagger, .fade-in');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-visible'); el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-visible');
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ io.observe(el); });
    setTimeout(function(){
      els.forEach(function(el){
        el.classList.add('is-visible');
        el.classList.add('visible');
      });
    }, 1800);
  }

  function setupScrollProgress(){
    var bar = document.getElementById('scrollProgress');
    if (!bar) return;
    var ticking = false;
    function update(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function setupBarCharts(){
    var bars = document.querySelectorAll('.bar-chart-fill[data-fill]');
    if (!bars.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      bars.forEach(function(b){ b.style.width = b.getAttribute('data-fill') + '%'; });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var el = e.target;
          el.style.width = el.getAttribute('data-fill') + '%';
          io.unobserve(el);
        }
      });
    }, { threshold: 0.3 });
    bars.forEach(function(b){ io.observe(b); });
  }


  function setupFAQ(){
    var toggles = document.querySelectorAll('.faq .faq-toggle');
    if (!toggles.length) return;
    toggles.forEach(function(btn){
      btn.addEventListener('click', function(){
        var faq = btn.closest('.faq');
        var open = faq.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open){
          document.querySelectorAll('.faq.open').forEach(function(o){
            if (o !== faq){
              o.classList.remove('open');
              var b = o.querySelector('.faq-toggle');
              if (b) b.setAttribute('aria-expanded','false');
            }
          });
        }
      });
    });
  }

  function setupSmoothAnchors(){
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }


  function setupCounters(){
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)){
      els.forEach(function(el){ el.textContent = el.getAttribute('data-end') || el.getAttribute('data-counter'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var end = parseFloat(el.getAttribute('data-end') || el.getAttribute('data-counter'));
        var start = performance.now();
        var dur = 1200;
        function tick(now){
          var t = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          var val = Math.round(end * eased);
          el.textContent = val;
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = end;
        }
        el.textContent = '0';
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function(el){ io.observe(el); });
  }


  function setupTOC(){
    var toc = document.getElementById('toc');
    if (!toc) return;
    var toggle = toc.querySelector('.toc-toggle');
    var list = toc.querySelector('.toc-list');
    if (toggle && list){
      toggle.addEventListener('click', function(){
        var open = toc.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Scroll-spy
    var links = toc.querySelectorAll('.toc-list a[href^="#"]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var sectionMap = {};
    links.forEach(function(a){
      var id = a.getAttribute('href').slice(1);
      var sec = document.getElementById(id);
      if (sec) sectionMap[id] = { section: sec, link: a };
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var id = e.target.id;
          links.forEach(function(l){ l.classList.remove('is-active'); });
          if (sectionMap[id]) sectionMap[id].link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
    Object.keys(sectionMap).forEach(function(id){ io.observe(sectionMap[id].section); });
  }

  function init(){
    setupReveal();
    setupCounters();
    setupScrollProgress();
    setupBarCharts();
    setupFAQ();
    setupSmoothAnchors();
    setupTOC();
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
